import { DataGrid } from '@mui/x-data-grid'

export default function TableData({
	rows,
	columns,
	checkboxSelection = true,
	pageSizeOptions = [5, 10, 25],
	initialPageSize = 10,
	height = '70dvh',
	sx,
	getRowId,
	hideFooter,
	...rest
}) {
	return (
		<div style={{ height, width: '100%' }}>
			<DataGrid
				getRowId={getRowId}
				rows={rows}
				columns={columns}
				checkboxSelection={checkboxSelection}
				disableRowSelectionOnClick
				pageSizeOptions={pageSizeOptions}
				initialState={{
					pagination: {
						paginationModel: { pageSize: initialPageSize, page: 0 },
					},
				}}
				hideFooter={hideFooter}
				disableColumnMenu={true}
				disableColumnSorting={true}
				sx={{
					border: 0,
					'& .MuiDataGrid-row': { borderRadius: 1 },
					// '& .MuiDataGrid-menuIcon': {
					// 	display: 'none',
					// },
					'& .MuiDataGrid-iconSeparator': {
						display: 'none',
					},
					'& .MuiDataGrid-filler .css-1tdeh38': {
						display: 'none',
					},
					'& .MuiDataGrid-row--borderBottom': {
						height: '48px !important',
					},

					'& .MuiCheckbox-root': {
						color: '#DFE4EB',
						'&.Mui-checked': {
							color: '#7ca6bd',
						},
					},
					'& .MuiDataGrid-cell': {
						display: 'flex',
						alignItems: 'center',
					},
					...sx,
				}}
				{...rest}
				className="table-wrp"
			/>
		</div>
	)
}
